import { render, staticRenderFns } from "./TestContainer.vue?vue&type=template&id=bc5d2aa8"
import script from "./TestContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./TestContainer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TestContainer.vue?vue&type=style&index=0&id=bc5d2aa8&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BannerTelegram: require('C:/projects/elena-elizarova.ru/elena-elizarova.ru-fe/src/components/BannerTelegram.vue').default,Grid: require('C:/projects/elena-elizarova.ru/elena-elizarova.ru-fe/src/components/Grid.vue').default})
